/* eslint-disable consistent-return */
/* eslint-disable no-else-return */
import firebase from "firebase";

export const askPermissionNotifications = async () => {
  try {
    const messaging = firebase.messaging();

    const permission = await Notification.requestPermission();

    if (permission === "denied") {
      console.log("Permission wasn't granted. Allow a retry.");
      return null;
    } else if (permission === "default") {
      console.log("The permission request was dismissed.");
      return null;
    }

    const token = await messaging.getToken();

    messaging.onMessage((payload) => {
      console.log(payload);
      console.log(payload.notification);
    });

    return token;
  } catch (error) {
    console.error(error);
  }
};
